class ImageIconList {
  constructor () {
    this.screen = null;
    this.mainSlider = null;
    this.thumbsSlider = null;
    this.pointMobile = 989;
    this.load();
  }

  load () {
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });

  }

  init () {
    if (this.setScreen()) {
      this.initSliders();
    }

    // window.addEventListener("resize", () => {
    //   this.setScreen();
    // });
    // this.setEventNextBtn();
  }

  // setEventNextBtn () {
  //   const elems = document.querySelector(".js-product-arrow-next");
  //   if (elems) {
  //     elems.addEventListener("click", () => {
  //       this.thumbsSlider.slideNext();
  //     });
  //   }
  // }

  setScreen () {
    let screenWidth = window.innerWidth >= this.pointMobile ? "desktop" : "mobile";
    if (screenWidth !== this.screen) {
      this.screen = screenWidth;
      this.initSliders();
    }
  }

  initSliders () {
    this.initThumbsSlider();
    this.initMainSlider();
  }

  initThumbsSlider () {
    const _this = this
    this.thumbsSlider = new Swiper(".js-image-icon-list", {
      slidesPerView: 1,
      effect: 'fade',
      clickable: true,
      autoplay: {
        delay: 5000
      },
      on: {
        slideChange (slide) {
          if(_this.mainSlider) _this.mainSlider.slideTo(slide.activeIndex);
        }
      }
    });
  }

  initMainSlider () {
    const _this = this
    this.mainSlider = new Swiper(".js-image-icon-list-text", {
      clickable: true,
      autoplay: {
        delay: 5000
      },
      thumbs: {
        swiper: this.thumbsSlider || ""
      },
      on: {
        click(slide) {
          if(_this.thumbsSlider) _this.thumbsSlider.slideTo(slide.clickedIndex);
        }
      },
      pagination: {
        el: document.querySelector(".js-product-slider-bullets"),
        type: "bullets",
        clickable: true,
        bulletActiveClass: "bullets__item--active",
        bulletClass: "bullets__item",
        renderBullet: function (index, className) {
          return "<span class=\"" + className + "\" ><span class=\"bullets__dot\">" + "</span></span>";
        }
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 'auto',
        }
      },
    });

  }
}

new ImageIconList();

